 /* RFQ Firefox Fix - Position Only */
  (function() {                                                                                                             var fixApplied = false;

    var checkInterval = setInterval(function() {
      if (typeof sb_jQuery !== 'undefined' && !fixApplied) {
        clearInterval(checkInterval);
        fixApplied = true;

        var $ = sb_jQuery;
        window.$ = sb_jQuery;
        window.jQuery = sb_jQuery;

        // Don't override click - just watch for popup opening
        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.target.classList &&
                mutation.target.classList.contains('sb_quote_form') &&
                mutation.target.classList.contains('sb_quote_form--open')) {

              // Fix position when popup opens
              var content = document.querySelector('.sb_quote_content');
              if (content) {
                content.style.setProperty('top', 'auto', 'important');
                content.style.setProperty('bottom', '20px', 'important');
              }
            }
          });
        });

        var quoteForm = document.querySelector('.sb_quote_form');
        if (quoteForm) {
          observer.observe(quoteForm, { attributes: true, attributeFilter: ['class'] });
        }

        console.log('RFQ Firefox Fix: Observer ready');
      }
    }, 50);
  })();